import React, { useEffect, useState, useMemo } from 'react';
import { Input } from 'antd';

import utils from 'utils/utils';
import { sanitizeString } from 'utils/xss';

const VariableInput = ({
  fallbackValueVariable,
  panelDataVariable,
  isSection,
  value,
  variable,
  language,
  transformVariableValue,
  handleKeyDown,
  onSaveVariable,
  htmlInVariable,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const array = [
    'number',
    'quote',
    'discount',
    'tax',
    'subTotal',
    'total',
    'createdDate',
    'sentDate',
    'expireDate',
  ];

  const isNumber = value === 'proposal' && array.includes(variable);

  const isFullName =
    variable === 'fullName' && ['client', 'client2', 'sender', 'sender2'].includes(value);
  const disabled = isSection || isNumber || isFullName;

  /*
  NOTE : simplified this in getCalculatedValue()
  const calculatedValue = isSection
    ? null
    : isNumber
    ? variables
      ? transformVariableValue(variable, variables[value][variable].value)
      : !!tempVariables[value][variable]?.value
      ? transformVariableValue(variable, tempVariables[value][variable].value)
      : ''
    : !!tempVariables[value][variable]?.value
    ? transformVariableValue(variable, tempVariables[value][variable].value)
    : '';
  */

  const getCalculatedValue = () => {
    if (isSection) {
      return null;
    }

    const source = panelDataVariable?.value ?? fallbackValueVariable?.value;
    return source ? transformVariableValue(variable, source) : '';
  };

  const placeholder = useMemo(() => {
    return value !== 'custom'
      ? `${utils.capitalizeFirstLetter(value)} ${utils.splitAndCapitaliseFirstLetter(variable)}`
      : 'Custom Value';
  }, [value, variable]);

  useEffect(() => {
    // while focused ignore the changes
    if (isFocused) {
      return;
    }

    setInputValue(getCalculatedValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelDataVariable]);

  const onChange = (e) => {
    const { value } = e.target;
    setInputValue(htmlInVariable ? value : sanitizeString(value));
  };

  const onBlur = () => {
    setTimeout(() => {
      setIsFocused(false);
    }, 1000);
    onSaveVariable(value, variable, inputValue, true);
  };

  if (disabled) {
    return (
      <Input
        className={`variables-input ${language}`}
        disabled={disabled}
        value={inputValue}
        placeholder={placeholder}
      />
    );
  }

  return (
    <Input
      className={`variables-input ${language}`}
      onChange={onChange}
      maxLength={htmlInVariable ? 2000 : 50}
      value={inputValue}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      onFocus={() => setIsFocused(true)}
      onBlur={onBlur}
      onPressEnter={onBlur}
    />
  );
};

export default VariableInput;
